/**
 * File Name          : lessons.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { DeviceFileSubscription } from "../../../projects/idl-physens/src/lib/models/subscription/device-file-sub.model";

export interface DatasnapLesson {
    id: string;
    title: string;
    scalars: string[];
    series: string[];
}

export interface DatasnapLevel {
    id: string;
    title: string;
    lessons: DatasnapLesson[];
}

export interface DatasnapUnit {
    id: string;
    title: string;
    iconPath: string;
    levels: DatasnapLevel[];
    subs: DeviceFileSubscription[]
}

export namespace ImpactFields {
    export const DROP_HEIGHT = 'drop_height';
    export const DROP_TIME = 'drop_time';
    export const MAX_VELOCITY = 'max_velocity';
    export const IMPACT_ACCEL = 'impact_accel';
    export const IMPACT_G = 'impact_g';
    export const IMPACT_FORCE = 'impact_force';
    export const DROP_ACCEL = 'drop_accel';
    export const ASTRONAUT_SURVIVAL = 'astronaut_survival';
    export const IMPACT_TIME = 'impact_time';
    export const EGG_SURVIVAL   = 'egg_survival';

    export const DISTANCE_SERIES = 'position';
    export const VELOCITY_SERIES = 'velocity';
    export const ACCELERATION_SERIES = 'acceleration';
}

export namespace AirRacerFields {
    export const AVERAGE_VELOCITY = 'average_velocity';
    export const MAX_VELOCITY = 'max_velocity';
    export const RACE_TIME = 'race_time';
    export const LAUNCH_ACCEL = 'launch_accel';
    export const LATERAL_DRIFT = 'lateral_drift';
    export const VERTICAL_DRIFT = 'vertical_drift';
    export const IMPACT_G = 'impact_g';


    // export const DISTANCE_SERIES = 'position';
    export const VELOCITY_SERIES = 'velocity';
    export const ACCELERATION_SERIES = 'acceleration';
}

export namespace ProjectileFields {
    export const FLIGHT_TIME = 'flight_time';
    export const HORIZONTAL_DISPLACEMENT = 'horizontal_displacement';
    export const LAUNCH_VELOCITY = 'launch_velocity';
    export const MAX_HEIGHT = 'max_height';


    export const HEIGHT_SERIES = 'height';
    export const VELOCITY_X_SERIES = 'velocityX';
    export const VELOCITY_Z_SERIES = 'velocityZ';

}

export const UNITS: DatasnapUnit[] = [
    {
        id: 'impact',
        title: 'Impact',
        iconPath: '/assets/Unit_Icons/Impact_Icon.svg',
        levels: [
            {
                id: 'standard',
                title: 'Standard',
                lessons: [
                    { id: '1', title: '1', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.DROP_TIME], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES] },
                    { id: '2', title: '2', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.DROP_TIME, ImpactFields.MAX_VELOCITY], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES] },
                    { id: '3', title: '3', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.DROP_TIME, ImpactFields.MAX_VELOCITY], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES] },
                    { id: '4', title: '4', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.MAX_VELOCITY, ImpactFields.IMPACT_FORCE], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES]  },
                    { id: '5', title: '5', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.IMPACT_G, ImpactFields.ASTRONAUT_SURVIVAL], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES]  },
                ]
            },
            { id: 'advanced', title: 'Advanced', lessons: [
                { id: '1', title: '1', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.DROP_TIME, ImpactFields.MAX_VELOCITY], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES] },
                { id: '2', title: '2', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.DROP_TIME, ImpactFields.MAX_VELOCITY, ImpactFields.IMPACT_ACCEL, ImpactFields.IMPACT_G], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES] },
                { id: '3', title: '3', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.DROP_TIME, ImpactFields.MAX_VELOCITY, ImpactFields.IMPACT_ACCEL, ImpactFields.IMPACT_G], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES] },
                { id: '4', title: '4', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.IMPACT_G, ImpactFields.ASTRONAUT_SURVIVAL], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES] },
                { id: '5', title: '5', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.DROP_TIME, ImpactFields.MAX_VELOCITY, ImpactFields.IMPACT_ACCEL, ImpactFields.IMPACT_G, ImpactFields.IMPACT_FORCE], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES] },
                { id: '6', title: '6', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.IMPACT_FORCE, ImpactFields.IMPACT_G, ImpactFields.IMPACT_TIME], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES]  },
                { id: '7', title: '7', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.IMPACT_FORCE, ImpactFields.IMPACT_G, ImpactFields.IMPACT_TIME], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES]  },
                { id: '8', title: '8', scalars: [ImpactFields.DROP_HEIGHT, ImpactFields.DROP_TIME, ImpactFields.IMPACT_FORCE, ImpactFields.IMPACT_G, ImpactFields.MAX_VELOCITY, ImpactFields.EGG_SURVIVAL], series: [ImpactFields.DISTANCE_SERIES, ImpactFields.VELOCITY_SERIES, ImpactFields.ACCELERATION_SERIES]}
            ] }
        ],
        subs: [
            { pubId: 8209, ds: 0 },
            { pubId: 12544, ds: 0 },
            { pubId: 8215, ds: 0 }
        ]
    },
    {
        id: 'projectile',
        title: 'Projectile',
        iconPath: '/assets/Unit_Icons/Projectile_Icon.svg',
        levels: [
            {
                id: 'standard',
                title: 'Standard',
                lessons: [
                    { id: '1', title: '1', scalars: [ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT], series: [ProjectileFields.HEIGHT_SERIES] },
                    { id: '2', title: '2', scalars: [ProjectileFields.LAUNCH_VELOCITY, ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] },
                    { id: '3', title: '3', scalars: [ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT, ProjectileFields.MAX_HEIGHT], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] },
                    { id: '4', title: '4', scalars: [ProjectileFields.LAUNCH_VELOCITY, ProjectileFields.HORIZONTAL_DISPLACEMENT, ProjectileFields.MAX_HEIGHT], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] },
                    { id: '5', title: '5', scalars: [ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT, ProjectileFields.MAX_HEIGHT], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] },
                    { id: '6', title: '6', scalars: [ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT,ProjectileFields.MAX_HEIGHT, ProjectileFields.LAUNCH_VELOCITY], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] }
                ]
            },
            { id: 'advanced', title: 'Advanced', lessons: [
                    { id: '1', title: '1', scalars: [ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT], series: [ProjectileFields.HEIGHT_SERIES] },
                    { id: '2', title: '2', scalars: [ProjectileFields.LAUNCH_VELOCITY, ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] },
                    { id: '3', title: '3', scalars: [ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT, ProjectileFields.MAX_HEIGHT], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] },
                    { id: '4', title: '4', scalars: [ProjectileFields.LAUNCH_VELOCITY, ProjectileFields.HORIZONTAL_DISPLACEMENT, ProjectileFields.MAX_HEIGHT], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] },
                    { id: '5', title: '5', scalars: [ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT, ProjectileFields.MAX_HEIGHT], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] },
                    { id: '6', title: '6', scalars: [ProjectileFields.FLIGHT_TIME, ProjectileFields.HORIZONTAL_DISPLACEMENT,ProjectileFields.MAX_HEIGHT, ProjectileFields.LAUNCH_VELOCITY], series: [ProjectileFields.HEIGHT_SERIES, ProjectileFields.VELOCITY_X_SERIES, ProjectileFields.VELOCITY_Z_SERIES] }
                ] }
        ],
        subs: [
            { pubId: 8209, ds: 0 },
            { pubId: 12544, ds: 0 },
            { pubId: 8215, ds: 0 }
        ]
    },
    {
        id: 'air_racer',
        title: 'Air Racer',
        iconPath: '/assets/Unit_Icons/AirRacer_Icon.svg',
        levels: [
            {
                id: 'standard',
                title: 'Standard',
                lessons: [
                    { id: '1', title: '1', scalars: [AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.MAX_VELOCITY, AirRacerFields.RACE_TIME], series: [AirRacerFields.VELOCITY_SERIES] },
                    { id: '2', title: '2', scalars: [AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.MAX_VELOCITY, AirRacerFields.RACE_TIME], series: [AirRacerFields.VELOCITY_SERIES] },
                    { id: '3', title: '3', scalars: [AirRacerFields.LAUNCH_ACCEL, AirRacerFields.MAX_VELOCITY, AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.RACE_TIME], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                    { id: '4', title: '4', scalars: [AirRacerFields.LAUNCH_ACCEL, AirRacerFields.MAX_VELOCITY, AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.RACE_TIME], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                    { id: '5', title: '5', scalars: [AirRacerFields.LATERAL_DRIFT, AirRacerFields.AVERAGE_VELOCITY], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                    { id: '6', title: '6', scalars: [AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.LATERAL_DRIFT, AirRacerFields.LAUNCH_ACCEL], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                    { id: '7', title: '7', scalars: [AirRacerFields.MAX_VELOCITY, AirRacerFields.IMPACT_G], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                    { id: '8', title: '8', scalars: [AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.IMPACT_G, AirRacerFields.LATERAL_DRIFT, AirRacerFields.VERTICAL_DRIFT], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] }
                ]
            },
            { id: 'advanced', title: 'Advanced', lessons: [
                { id: '1', title: '1', scalars: [AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.MAX_VELOCITY, AirRacerFields.RACE_TIME], series: [AirRacerFields.VELOCITY_SERIES] },
                { id: '2', title: '2', scalars: [AirRacerFields.LAUNCH_ACCEL, AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.MAX_VELOCITY, AirRacerFields.RACE_TIME], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                { id: '3', title: '3', scalars: [AirRacerFields.LAUNCH_ACCEL, AirRacerFields.MAX_VELOCITY, AirRacerFields.RACE_TIME], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                { id: '4', title: '4', scalars: [AirRacerFields.LATERAL_DRIFT, AirRacerFields.AVERAGE_VELOCITY], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                { id: '5', title: '5', scalars: [AirRacerFields.LATERAL_DRIFT, AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.MAX_VELOCITY, AirRacerFields.LAUNCH_ACCEL], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                { id: '6', title: '6', scalars: [AirRacerFields.MAX_VELOCITY, AirRacerFields.RACE_TIME, AirRacerFields.VERTICAL_DRIFT, AirRacerFields.LAUNCH_ACCEL, AirRacerFields.AVERAGE_VELOCITY], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                { id: '7', title: '7', scalars: [AirRacerFields.MAX_VELOCITY, AirRacerFields.IMPACT_G], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] },
                { id: '8', title: '8', scalars: [AirRacerFields.AVERAGE_VELOCITY, AirRacerFields.IMPACT_G, AirRacerFields.LATERAL_DRIFT, AirRacerFields.VERTICAL_DRIFT], series: [AirRacerFields.VELOCITY_SERIES, AirRacerFields.ACCELERATION_SERIES] }
            ] }
        ],
        subs: [
            { pubId: 8209, ds: 1 },
            // { pubId: 12544, ds: 0 }, // HighG Accl
            { pubId: 8215, ds: 1 }
        ]
    },
    
];